// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1A5oz","notFound":"styles_notFound__1gDpT","desc":"styles_desc__LPIub"};